
import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { UtilisateurService } from './utilisateur.service';
import { UtilisateurDataService } from './utilisateur-data.service';
import { AuthService } from './auth.service';
import { NomEnvironment } from 'src/models/nom-environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { CodeErreur, isDemoLimitErrorCode } from 'src/enum/codeErreur';

@Injectable({
  providedIn: 'root'
})
export class ServerErrorInterceptorService implements HttpInterceptor {

  private static readonly DUREE_MESSAGE_LIMITE_DEMO = 8000;
  private static readonly DUREE_MESSAGE_ERREUR = 5000;

  constructor(private route: Router, private injector: Injector) { }

  private obtenirMessageErreur(error: HttpErrorResponse, translate: TranslateService): string {
    if (error.error?.codeErreur === CodeErreur.LIMITE_DEMO_ATTEINTE) {
      return translate.instant('USERS_MANAGEMENT.DEMO_USER_LIMIT_ERROR', { limite: error.error.limite });
    }

    if (error.error?.codeErreur === CodeErreur.LIMITE_DEMO_CONTENUS_ATTEINTE) {
      return translate.instant('PACKAGES_PERSO_MANAGEMENT.DEMO_CONTENT_LIMIT_ERROR', { limite: error.error.limite });
    }

    if (error.error?.codeErreur === CodeErreur.LIMITE_DEMO_CREATION_ATTEINTE) {
      return translate.instant('PACKAGES_PERSO_MANAGEMENT.DEMO_CREATION_LIMIT_ERROR', { limite: error.error.limite });
    }

    if (error.error?.codeErreur === CodeErreur.LIMITE_DEMO_TYPE_CONTENU_ATTEINTE) {
      return translate.instant('PACKAGES_PERSO_MANAGEMENT.DEMO_CONTENT_TYPE_ERROR');
    }

    if (error.error?.codeErreur === CodeErreur.LIMITE_DEMO_VISIONNEMENTS_ATTEINTE) {
      return translate.instant('PACKAGES_PERSO_MANAGEMENT.DEMO_VIEWING_LIMIT_ERROR', { limite: error.error.limite });
    }

    return translate.instant('COMMUN.OPERATION_NON_PERMISE');
  }

  private estErreurLimiteDemo(error: HttpErrorResponse): boolean {
    return isDemoLimitErrorCode(error.error?.codeErreur);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const { status, message } = error;

        if(environment.name === NomEnvironment.Development || environment.name === NomEnvironment.Essais) {
          console.error(`Backend returned ${JSON.stringify(error)}`);
        }

        if (error.status === 401) {

          return throwError(() => error);
        }

        if (error.status === 422) {
          const translate = this.injector.get(TranslateService);
          const snackBar = this.injector.get(MatSnackBar);
          const messageErreur = this.obtenirMessageErreur(error, translate);
          const isDemoLimit = this.estErreurLimiteDemo(error);

          snackBar.open(
            messageErreur,
            translate.instant('COMMUN.CLOSE'),
          { duration: isDemoLimit ? ServerErrorInterceptorService.DUREE_MESSAGE_LIMITE_DEMO : ServerErrorInterceptorService.DUREE_MESSAGE_ERREUR }
          );

          if (isDemoLimit) {
            return throwError(() => error);
          }

          return EMPTY;
        }

        this.route.navigate(['/novo-page-erreur'], {
            queryParams: { error: JSON.stringify({ status, message }) }
        });

        return throwError(() => error);
      })
    )
  }
}
